import React from 'react';
import PropTypes from 'prop-types';

import { CollapseIcon, ExpandIcon } from '../img';
import styles from './CollapseButton.css';

const IPropTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
  collapsed: false,
};

const CollapseButton = props => (
  <button
    className={[styles.actionButton, props.className].join(' ')}
    onClick={props.onClick}
  >
    {
      props.collapsed ?
        (
          <React.Fragment>
            <img src={ExpandIcon} alt="" className={styles.image} />
            <span className={styles.actionText}> Expandir </span>
          </React.Fragment>
        )
      : (
        <React.Fragment>
          <img src={CollapseIcon} alt="" className={styles.image} />
          <span className={styles.actionText}> Colapsar </span>
        </React.Fragment>
        )
    }
  </button>
);

CollapseButton.propTypes = IPropTypes;
CollapseButton.defaultProps = defaultProps;

export { CollapseButton };



// WEBPACK FOOTER //
// ./src/common/compare-section/collapse-button/CollapseButton.jsx